import React from 'react'
import Header from '../Menpages/Header/Main'
import Footer from '../Menpages/Footer/Main'
import Bredcom from '../Menpages/Bredcom/Main'
import Life from '../MenportfolioDetails/Life'
import Latest from '../MenportfolioDetails/Latest'
import Slider from '../Menpages/GlobleSlider/Main'

function Main() {
  return (
    <>
        <div className="page-wrapper">
            <Header/>
            <Bredcom title={"Home"} head={"Portfolio Masonry"} sbtitle={"Portfolio Masonry"}/>
            <Life/>
            <Latest/>
            <Slider/>
            <Footer/>
        </div>
    </>
  )
}

export default Main